import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { LoggingService } from '@lib-ui/lib/services/logging.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements ErrorHandler {
  private readonly loggingService = inject(LoggingService);

  handleError(error: Error | HttpErrorResponse) {
    this.loggingService.logException(error);
  }
}
